export default {
  error: {
    title: 'No se puede cargar la página',
    description:
      'Ocurrió un error al cargar la página. Por favor vuelve a cargar el navegador, si el error persiste escribe a',
  },
};
